import httpClient from '@/shared/http-tms-client';

const getContactType = (userId) => httpClient.get(`/eServicesUserContacts/${userId}`);
const getCompanies = () => httpClient.get('/Companies');
const getEServicesContacts = (sourceCompanyId) => httpClient.get(`/eServicesContacts/${sourceCompanyId}`);

export {
  getCompanies,
  getContactType,
  getEServicesContacts,
};
